<template>
  <div
    id="collect-balance-modal"
    aria-hidden="true"
    class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
  >
    <div class="relative p-4 w-full max-w-2xl max-h-full">
      <div class="relative bg-gray-700 rounded-lg shadow">
        <div
          class="flex items-center justify-between px-4 py-2 border-b border-gray-600 rounded-t"
        >
          <h3 class="font-semibold text-base uppercase">Collect Balance</h3>
          <button
            type="button"
            class="text-gray-400 bg-transparent rounded-lg text-sm w-6 h-6 ms-auto inline-flex justify-center items-center hover:bg-gray-600 hover:text-white"
            @click="this.modal.hide()"
          >
            <svg
              class="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
          </button>
        </div>
        <div class="px-4 pt-4 pb-8">
          <input
            placeholder="Recipient address"
            type="text"
            v-model="recipientAddress"
            class="w-96 py-1.5 px-2 text-sm bg-transparent rounded-xl border border-gray-500 focus:outline-none focus:ring-0"
          />
          <div class="mt-4 pb-8 max-h-[420px] overflow-y-auto space-y-2 pr-4">
            <collect-balance
              v-for="wallet in this.wallets"
              :key="wallet.address"
              :wallet="wallet"
              :execute-exclude-wallet="this.executeExcludeWallet"
              :active="this.open"
              :recipient-address="this.recipientAddress"
              :execute-address="this.executeAddress"
            ></collect-balance>
          </div>
          <div class="mt-4 flex justify-end">
            <div
              class="flex gap-1 justify-center bg-neutral-700 items-center px-5 py-1.5 text-sm uppercase font-bold rounded-xl cursor-pointer text-gray-200"
              :class="{
                'cursor-not-allowed shadow shadow-gray-500': this.onSubmit,
                'shadow shadow-blue-500 hover:shadow-blue-400': !this.onSubmit,
              }"
              @click="this.submit"
            >
              <svg
                v-if="this.onSubmit"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-5 animate-spin"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                />
              </svg>
              <span>Submit</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CollectBalance from "@/components/Solana/CollectBalance.vue";
import { Modal } from "flowbite";
import { mapGetters } from "vuex";

export default {
  name: "CollectBalanceModal",
  components: { CollectBalance },
  props: {
    open: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      modal: null,
      hidden: false,
      recipientAddress: "",
      onSubmit: false,
      excludeWallet: [],
      executeAddress: "",
    };
  },
  computed: {
    ...mapGetters("wallet", ["wallets"]),
    ...mapGetters("solana", ["validateAddress"]),
  },
  watch: {
    open() {
      if (this.open === true) {
        this.excludeWallet = [];
        this.recipientAddress = "";
        this.modal.show();
      }
    },
  },
  methods: {
    executeExcludeWallet(wallet, excluded = true) {
      let data = this.excludeWallet;
      if (excluded) {
        data.push(wallet);
      } else {
        data = data.filter((item) => item.address !== wallet.address);
      }
      this.excludeWallet = data;
    },
    async submit() {
      this.onSubmit = true;
      if (!(await this.validateAddress(this.recipientAddress))) {
        this.$store.commit("toast/add", {
          type: "danger",
          title: "Recipient address is invalid.",
        });
        this.onSubmit = false;
        return;
      }
      let executeWallet = this.wallets.filter(
        (wallet) =>
          !this.excludeWallet.some(
            (exclude) => exclude.address === wallet.address
          )
      );
      executeWallet = executeWallet.filter(
        (wallet) => wallet.balanceNative > 0.001
      );
      executeWallet = executeWallet.filter(
        (wallet) => wallet.address !== this.recipientAddress
      );
      let index = 0;
      while (index < executeWallet.length) {
        this.executeAddress = executeWallet[index].address;
        await new Promise((resolve) => setTimeout(resolve, 1000));
        index++;
      }
      this.onSubmit = false;
    },
  },
  mounted() {
    this.modal = new Modal(document.getElementById("collect-balance-modal"), {
      placement: "center",
      backdropClasses:
        "bg-gray-900 bg-opacity-50 bg-opacity-80 fixed inset-0 z-40",
      onHide: () => {
        this.$parent.openCollectBalanceModal = false;
      },
    });
  },
  beforeUnmount() {
    this.$parent.openCollectBalanceModal = false;
  },
};
</script>
